import { render } from "./WelcomeScreenMinimalTheme.vue?vue&type=template&id=67962f49&scoped=true"
import script from "./WelcomeScreenMinimalTheme.vue?vue&type=script&lang=js"
export * from "./WelcomeScreenMinimalTheme.vue?vue&type=script&lang=js"

import "./WelcomeScreenMinimalTheme.vue?vue&type=style&index=0&id=67962f49&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67962f49"]])

export default __exports__